import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { detect } from 'detect-browser';
import { logErrorThunk, trackEventThunk } from 'redux/slices/miscSlice';
const browser = detect();

const useHandleTrackEvent = () => {
  const dispatch = useDispatch();
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const currentUser = useSelector((state) => state.auth.currentUser);
  const { pathname } = useLocation();

  const handleTrackEvent = (eOrType, typeOrData = {}, ...rest) => {
    let eventType;
    let customData = {};

    if (typeof eOrType === 'string') {
      eventType = eOrType;
      customData = typeOrData;
    } else {
      eventType = typeOrData;
      // In case the old signature (e, type, customData) was used
      if (rest[0] && typeof rest[0] === 'object') {
        customData = rest[0];
      }
    }

    const userInfo =
      currentUser || JSON.parse(localStorage.getItem('userInfo') || '{}');
    try {
      dispatch(
        trackEventThunk({
          context: customData?.context || 'click_event',
          eventType: eventType,
          userId: isLoggedIn ? userInfo?.id : null,
          time: new Date().getTime(),
          os: browser?.os,
          sessionId: isLoggedIn
            ? userInfo?.id
            : sessionStorage.getItem('trackingSessionId'),
          customData: {
            page_path: pathname,
            browser: browser?.name,
            browser_version: browser?.version,
            ...customData,
          },
        }),
      );
    } catch (e) {
      console.error('Tracking Error:', e);
      dispatch(
        logErrorThunk({
          message: e?.message,
          data: {
            formatted: {
              errorText: e?.message,
              severity: 'error',
            },
            raw: e,
          },
        }),
      );
    }
  };

  return handleTrackEvent;
};

export default useHandleTrackEvent;
